export const URL_VALIDATE_REGEX = /^(http:\/\/|https:\/\/)/;
export const RECIPE_PATH_REGEX = /^\/recipe/;
export const CATEGORY_ID_VALIDATE_REGEX = /^\d+$/;

export enum BANNER_TYPES {
  MANUAL = 'manual',
  IMAGE = 'image'
};

export enum COMPONENTS {
  BANNER = 'banner',
  GROUP = 'group',
  CATEGORY = 'category'
}

export enum SOURCE {
  BANNER = 'banner',
  HOMEPAGE = 'homepage',
  LISTVIEW = 'listview'
}

export enum RECIPE_OPEN_SOURCE {
  HOMEPAGE = 'homepage',
  BANNER = 'banner',
  SEARCH = 'search',
  EXPLORE = 'explore'
}

export enum HOMEPAGE_ROW_TYPE {
  BANNER = 'banner',
  CATEGORY = 'category',
  GROUP = 'group'
}
